import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { CountryRepository } from '@app/domain/ports/country.repository';
import { Country } from '@app/domain/models/country.model';
import { CountryDto, mapCountryDtoToDomain } from '@app/data/mappers/country.mapper';

/**
 * Data source real del catálogo de países.
 *
 * El JSON (~50KB) se sirve como asset estático y se descarga en runtime vía
 * HttpClient: NO entra en el bundle JS inicial (los assets se copian, no se
 * empaquetan). La respuesta se cachea con `shareReplay(1)` para una sola
 * descarga por sesión.
 */
@Injectable()
export class CountryRemoteDataSource extends CountryRepository {
  private readonly http = inject(HttpClient);
  private readonly countriesUrl = 'assets/data/countries.json';
  private countries$?: Observable<Country[]>;

  getCountries(): Observable<Country[]> {
    if (!this.countries$) {
      this.countries$ = this.http.get<CountryDto[]>(this.countriesUrl).pipe(
        map(response => response.map(mapCountryDtoToDomain)),
        shareReplay(1),
      );
    }
    return this.countries$;
  }
}
